<!--Alert Table-->
<div>
	<caass-scan-reminder-table (Selected)="onReminderSelected($event)"> </caass-scan-reminder-table>
</div>

<!--Person Table-->
<div>
	<caass-scan-reminder-person-table [SelectedStationReminderAlert]="SelectedStationReminderAlert" (Updated)="onPersonTableUpdated($event)">
	</caass-scan-reminder-person-table>
</div>
